import { Button } from '@chakra-ui/react'

import { getArticleUrl } from '@/client/services/url/faq'

import ShwLink from '@/components/ShwLink'

export default function CollegePartnershipsLearnMoreButton({
  text = 'Learn More',
  variant = 'outline',
}: {
  text?: string
  variant?: string
}): JSX.Element {
  return (
    <ShwLink href={getArticleUrl('what-is-a-portfolio')}>
      <Button variant={variant}>{text}</Button>
    </ShwLink>
  )
}
